import React from 'react';
import Register from '../../components/auth/Register';

const RegisterPage: React.FC = () => {
  return <Register />;
};

export default RegisterPage; 